import React, { useState, useEffect, useCallback } from "react";
import { Button } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  SemanticButton,
  CellContainer,
  Checkbox,
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";
import { producaov2 as api } from "../../../../services/apis";

const Faixas = (props) => {
  const [faixas, setFaixas] = useState([]);

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  useEffect(() => {
    api
      .get(`faixas`)
      .then((res) => {
        let array = { local: "faixas", texto: `listou as faixas` };
        api.post("system_logs", { acao: JSON.stringify(array) });
        setFaixas(res.data);
      })
      .catch((err) => {
        console.error(err);
        // swal('Não foi possível carregar as faixas', '', '').then(res => props.history.push('/'));
      });
  }, []);

  const deleteFaixa = useCallback(
    (id) => {
      swal("Remoção de faixa", "Você tem certeza que quer remover? ", "").then(
        (res) => {
          if (res) {
            api.delete(`faixas/${id}`).then((res) => {
              let array = {
                local: "faixas",
                texto: `deletou a faixa de id=${id}`,
              };
              api.post("system_logs", { acao: JSON.stringify(array) });
              const newFaixas = [...faixas].filter((faixa) => faixa.id !== id);
              setFaixas(newFaixas);
            });
          }
        }
      );
    },
    [faixas]
  );

  const handleActive = useCallback((index) => {
    const newFaixas = [...faixas];
    const id = newFaixas[index].id;
    const active = !newFaixas[index].active;

    api
      .put(`faixas/${id}`, { active })
      .then(() => {
        newFaixas.map((faixa) => {
          faixa.active = false;
        });
        newFaixas[index].active = active;
        setFaixas(newFaixas);
      })
      .catch((err) => {
        console.error(err);
        swal("Não foi mudar o status da faixa", "", "").then((res) =>
          props.history.push("/")
        );
      });
  });

  const handleActiveTimer = useCallback((index) => {
    const newFaixas = [...faixas];
    const id = newFaixas[index].id;

    const faixaAtualizada = !newFaixas[index].timer_active;

    api
      .put(`faixas/${id}`, { timer_active: faixaAtualizada })
      .then(() => {
        newFaixas[index].timer_active = faixaAtualizada;
        setFaixas(newFaixas);
      })
      .catch((err) => {
        console.error(err);
        swal("Não foi possível mudar o status da faixa", "", "").then((res) =>
          props.history.push("/")
        );
      });
  });

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Faixas</Title>

          <ContainerInputSearch className="ui fluid left icon input">
            <CreateButton to="/admin/faixas/criar" target="_blank">
              Criar
            </CreateButton>
          </ContainerInputSearch>

          <SemanticTable size="big" celled style= {{ overflowX: "scroll"}}>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Enunciado</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Enunciado Botão
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Link</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Cor da Faixa
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Cor do Botao
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Status</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Temporizador
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Controles</SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>

            <SemanticTable.Body>
              {faixas.map((faixa, index) => (
                <SemanticTable.Row>
                  <SemanticTable.Cell>{faixa.id}</SemanticTable.Cell>
                  <SemanticTable.Cell>{faixa.enunciado}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {faixa.enunciado_botao}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>{faixa.link}</SemanticTable.Cell>
                  <SemanticTable.Cell>{faixa.cor_faixa}</SemanticTable.Cell>
                  <SemanticTable.Cell>{faixa.cor_botao}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <Checkbox
                      checked={faixa.active}
                      onClick={(e) => handleActive(index)}
                    />
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <Checkbox
                      checked={faixa.timer_active}
                      onClick={(e) => handleActiveTimer(index)}
                    />
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <CellContainer>
                      <Button
                        icon="edit icon"
                        color={"blue"}
                        onClick={() =>
                          window.open(`/admin/faixas/editar/${faixa.id}`)
                        }
                      />

                      <Button
                        icon="trash icon"
                        color={"red "}
                        onClick={() => deleteFaixa(faixa.id)}
                      />
                    </CellContainer>
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))}
            </SemanticTable.Body>
          </SemanticTable>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(Faixas);
